import { Link } from "react-router-dom";
import IconArrow from "../SvgIcon/IconArrow";

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  const handlePrev = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

 const formatPage = (page) => page.toString().padStart(2, '0');

  return (
    <div className="pagination d-flex align-items-center gap-2">
      <Link
        to="#"
        className={`prev ${currentPage > 1 ? "active" : ""}`}
        onClick={handlePrev}
        data-bs-toggle="tooltip"
        data-bs-placement="left"
        title="Previous"
      >
        <IconArrow />
      </Link>

      <span>
        {formatPage(currentPage)} of {formatPage(totalPages)}
      </span>

      <Link
        to="#"
        className={`next ${currentPage < totalPages ? "active" : ""}`}
        onClick={handleNext}
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        title="Next"
      >
        <IconArrow />
      </Link>
    </div>
  );
}
